import { Box, Button, CircularProgress, FormControl, Grid, IconButton, InputLabel, LinearProgress, MenuItem, Pagination, Select, Tooltip, Typography } from '@mui/material'
import { ArrowDropDownIcon, DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../global/config/Reducer';
import dayjs from 'dayjs';
import { useNavigate } from 'react-router-dom';
import { setSelectedMonth } from '../../global/config/Reducer/MonthSlice';
import { Download, MilitaryTechOutlined, NorthOutlined, PendingActions, ReportProblemOutlined, Security, SouthOutlined, TaskOutlined, VisibilityOutlined, WatchLaterOutlined } from '@mui/icons-material';
import VenueChecklistList from './VenueChecklistList';
import { ApiGetChecklistPdf, ApiGetChecklistSubmissionList, ApiGetVenueDashboard, ApiGetAreaChecklistDashboard, ApiGetVenueList, ApiGetVenueManagerChecklistList, ApiRegionVenues } from '../../apiService/Core/Apicall';
import storage from '../../utils/storage';
import { RegionList, setRegion } from '../../global/config/Reducer/RegionSlice';
import { toast } from 'react-toastify';
import ChecklistChart from '../../Components/Charts/ChecklistChart';
import RoundChart from '../../Components/Charts/RoundChart';
import Domains from '../../global/constants/domain';

interface VenueChecklistDashboardProps {
    checkListType?: string;
    setCheckListType?: (val: string) => void;
}

function VenueChecklistDashboard({ checkListType: propCheckListType, setCheckListType }: VenueChecklistDashboardProps) {
    const checkListType = propCheckListType || storage.getItem('dashboardCheckListType') || "BUSINESS";
    const isAreaManager = checkListType === "AREA_MANAGER";
    const userRole = storage.getItem('userRole');
    const selectedMonth = useSelector((state: RootState) => state.month.selectedMonth)
    const dispatch = useDispatch()
    const [month, setmonth] = useState<any>(dayjs(selectedMonth))
    const navigate = useNavigate()
    const [venuelist, setvenuelist] = useState<any[]>([])
    const [venues, setvenues] = useState<number | string>('')
    const clientEntity = useSelector((state: RootState) => state.clientEntity.selectedEntity)
    const Regions = useSelector(RegionList)
    const [selectedRegion, setselectedRegion] = useState<number | ''>(Regions[0]?.regionId ?? '')
    const [dashboard, setDashboard] = useState<any>([])
    const [submittedChecklist, setSubmittedChecklist] = useState<any>([])
    const [page, setPage] = useState(1);
    const limit = 5;
    const [totalCount, setTotalCount] = useState(0);

    const [pages, setPages] = useState<any>({}); // { cardKey: pageNumber }
    const rowsPerPage = 5;

    // const isNotMM = (window.location.hostname.includes(Domains.ALDI)) ? "bg-light-main" : "bg-light-main2"
    const isNotMM = "border"


    //     const getIconColorByDomain = () => {
    //     const domain = window.location.hostname;

    //     if (domain.includes(Domains.ALDI)) return '#001F79';
    //     if (domain.includes(Domains.BLOOMS)) return '#1C2B90';
    //     if (domain.includes(Domains.MM)) return '#ADB792';

    //     return '#ADB792';
    // };


    const getPage = (key: any) => pages[key] || 1;

    const setPage2 = (key: string, pageNum: number) => {
        setPages((prev: any) => ({ ...prev, [key]: pageNum }));
    };
    const getTotalPages = (key: string, dataArr: any) => Math.ceil((dataArr?.length || 0) / rowsPerPage);

    const getPaginatedData = (key: string, dataArr: any) => {
        const currentPage = getPage(key);
        return (
            dataArr?.slice(
                (currentPage - 1) * rowsPerPage,
                currentPage * rowsPerPage
            ) || []
        );
    };

    useEffect(() => {
        setmonth(dayjs(selectedMonth))
    }, [selectedMonth])



    const GetDashboard = async () => {
        try {
            const isAreaManager = checkListType === "AREA_MANAGER";
            const areaId = storage.getItem("areaId");
            const areaIdParam = (areaId && areaId !== "undefined" && areaId !== "null") ? `&areaId=${areaId}` : '';
            const data = isAreaManager
                ? `?year=${month.year()}&clientEntityId=${storage.getItem("clientEntityId")}${areaIdParam}&month=${month.month() + 1}`
                : `?year=${month.year()}&clientEntityId=${storage.getItem("clientEntityId")}&venueId=${venues}&month=${month.month() + 1}`;
            const res = isAreaManager
                ? await ApiGetAreaChecklistDashboard(data)
                : await ApiGetVenueDashboard(data);
            setDashboard(res?.data)
        } catch (error: any) {
            toast.error(error?.message)
        }
    }

    const GetSubmittedChecklistList = async (currentPage = page) => {
        try {
            const offset = (currentPage - 1) * limit;
            const isAreaManager = checkListType === "AREA_MANAGER";
            const areaId = storage.getItem("areaId");
            const areaIdParam = (isAreaManager && areaId && areaId !== "undefined" && areaId !== "null") ? `&areaId=${areaId}` : '';
            const data = `?month=${month.month() + 1}&year=${month.year()}&clientEntityId=${storage.getItem('clientEntityId')}${isAreaManager ? areaIdParam : `&venueId=${venues}`}&offset=${offset}&limit=${limit}&status=SUBMITTED&isRecentNeeded=true&checkListType=${checkListType}`
            const res = await ApiGetChecklistSubmissionList(data)
            if (res?.status || res?.success) {
                setSubmittedChecklist(res?.data)
                setTotalCount(res?.totalCount || res?.count || 0);
            }
        } catch (error: any) {
            toast.error(error)
        }
    }

    useEffect(() => {
        const isAreaManager = checkListType === "AREA_MANAGER";
        if (isAreaManager || venues) {
            GetDashboard();
        }
    }, [venues, month, checkListType])

    useEffect(() => {
        const isAreaManager = checkListType === "AREA_MANAGER";
        if (isAreaManager || venues) {
            GetSubmittedChecklistList(page);
        }
    }, [page, month, venues, checkListType]);


    useEffect(() => {
        const RegionList = async () => {
            if (storage.getItem("clientEntityId") && storage.getItem('ClientGroupName') === "ALDI") {
                const data = `?clientEntityId=${storage.getItem("clientEntityId")}${storage.getItem('areaId') ? `&areaId=${storage.getItem('areaId')}` : ''}`

                const response3 = await ApiRegionVenues(data)
                dispatch(setRegion(response3.data))
            }
        }
        RegionList()
    }, [clientEntity])

    useEffect(() => {
        if (Regions.length > 0 && !selectedRegion) {
            setselectedRegion(Regions[0].regionId);
            setvenuelist(Regions[0].venues)
            // setvenues(Regions[0].venues[0].venueId)
        }
    }, [Regions, clientEntity]);

    useEffect(() => {
        const Venuelist = async () => {
            if (!window.location.hostname.includes('aldi')) {
                try {
                    const clientEntityId: any = storage.getItem('clientEntityId')
                    const response = await ApiGetVenueList(clientEntityId);
                    console.log(response)
                    setvenuelist(response.data);
                    setvenues(response?.data[0]?.venueId)
                } catch (error: any) {
                    toast.error(error)
                }
            }
            else {
                const finalregion = Regions && Regions.find((region: any) => region.regionId === selectedRegion)?.venues;
                setvenuelist(finalregion)
                if (finalregion && finalregion.length > 0) {
                    setvenues(finalregion[0].venueId)
                }

            }

        };
        Venuelist();

    }, [selectedRegion, clientEntity])


    const overview = {
        ...dashboard?.overview,
        totalCompliancePercentage: dashboard?.overview?.totalCompliancePercentage,
        complianceChangePercentage: dashboard?.overview?.complianceChangePercentage !== undefined 
            ? dashboard?.overview?.complianceChangePercentage 
            : (dashboard?.overview?.percentage !== undefined ? dashboard?.overview?.percentage : 0),
        totalDueTillToday: dashboard?.overview?.totalDueTillToday !== undefined 
            ? dashboard?.overview?.totalDueTillToday 
            : (dashboard?.overview?.totalOutStandingCheckListCount !== undefined ? dashboard?.overview?.totalOutStandingCheckListCount : 0),
        todayDueCount: dashboard?.overview?.todayDueCount !== undefined 
            ? dashboard?.overview?.todayDueCount 
            : (dashboard?.overview?.totalOutStandingCheckListCount !== undefined ? dashboard?.overview?.totalOutStandingCheckListCount : 0),
        overdueCount: dashboard?.overview?.overdueCount !== undefined 
            ? dashboard?.overview?.overdueCount 
            : 0,
        completionRate: dashboard?.overview?.completionRate !== undefined 
            ? dashboard?.overview?.completionRate 
            : (dashboard?.overview?.totalSubmittedCheckListCount !== undefined 
                ? Math.round((dashboard?.overview?.totalSubmittedCheckListCount / ((dashboard?.overview?.totalSubmittedCheckListCount || 0) + (dashboard?.overview?.totalOutStandingCheckListCount || 0))) * 100) 
                : 0),
        failurePercentage: dashboard?.overview?.failurePercentage !== undefined 
            ? dashboard?.overview?.failurePercentage 
            : (dashboard?.overview?.totalFailedPercentage !== undefined ? dashboard?.overview?.totalFailedPercentage : 0),
        failureChangePercentage: dashboard?.overview?.failureChangePercentage !== undefined 
            ? dashboard?.overview?.failureChangePercentage 
            : (dashboard?.analytics?.failedSubmission?.percentage !== undefined 
                ? dashboard?.analytics?.failedSubmission?.percentage 
                : 0)
    };

    const checklistPerformance = isAreaManager ? (() => {
        const submitted = dashboard?.overview?.totalSubmittedCheckListCount || 0;
        const outstanding = dashboard?.overview?.totalOutStandingCheckListCount || 0;
        const scheduled = submitted + outstanding;
        const passed = dashboard?.overview?.totalComplianceCheckListCount || 0;
        const failed = dashboard?.overview?.totalFailureCheckListCount || 0;

        return {
            scheduledCount: scheduled,
            scheduledPercentage: 100,
            submittedCount: submitted,
            submittedPercentage: scheduled > 0 ? Math.round((submitted / scheduled) * 100) : 0,
            passedCount: passed,
            passedPercentage: submitted > 0 ? Math.round((passed / submitted) * 100) : 0,
            failedCount: failed,
            failedPercentage: submitted > 0 ? Math.round((failed / submitted) * 100) : 0,
            notSubmittedCount: outstanding,
            notSubmittedPercentage: scheduled > 0 ? Math.round((outstanding / scheduled) * 100) : 0,
        };
    })() : dashboard?.checklistPerformance;

    const failureByChecklist = isAreaManager ? {
        list: dashboard?.failedQuestions?.list?.map((item: any) => ({
            checklistName: item.questionTitle,
            checkListFailedPercentage: dashboard?.failedQuestions?.totalQuestionsFailedCount > 0 
                ? Math.round((item.failCount / dashboard.failedQuestions.totalQuestionsFailedCount) * 100)
                : 0
        })) || []
    } : dashboard?.failureByChecklist;

    const analytics = {
        ...dashboard?.analytics,
        totalSubmittedCount: dashboard?.analytics?.totalSubmittedCount || dashboard?.analytics?.submittedChecklist,
        totalFailedCount: dashboard?.analytics?.totalFailedCount || dashboard?.analytics?.failedSubmission,
        complianceRate: dashboard?.analytics?.complianceRate,
        lastSixMonths: dashboard?.analytics?.lastSixMonths || []
    };

    const recentIssuesData = (isAreaManager
        ? (dashboard?.recentFails || dashboard?.recentIssues || [])
        : (dashboard?.recentIssues || dashboard?.recentFails || [])
    ).map((item: any) => ({
        ...item,
        questionTitle: item.questionTitle || item.question || item.checklistQuestionTitle || item.areaName || "",
        lastReportedOn: item.lastReportedOn || item.failedOn || item.submittedOn || new Date(),
        status: item.status || "FAIL"
    }));

    const riPage = getPage('ri');
    const riTotalPages = getTotalPages('ri', recentIssuesData);
    const riPaginatedData = getPaginatedData('ri', recentIssuesData);


    const cbcPage = getPage('cbc');
    const cbcTotalPages = getTotalPages('cbc', dashboard?.complianceByCategory);
    const cbcPaginatedData = getPaginatedData('cbc', dashboard?.complianceByCategory);

        const downloadChecklist = async (id:string|number, name:string, areaId?: string | number) => {
        // const data = `?clientEntityId=${storage.getItem('clientEntityId')}&year=${month.year()}&month=${month.month() + 1}&venueId=${venues}`;
        const checkAreaId = areaId || storage.getItem('areaId');
        const areaIdParam = (checkListType === "AREA_MANAGER" && checkAreaId && checkAreaId !== "undefined" && checkAreaId !== "null") ? `&areaId=${checkAreaId}` : '';
        const data = `?businessCheckListSubmissionId=${id}&clientEntityId=${storage.getItem('clientEntityId')}&checkListType=${checkListType}${areaIdParam}`;

        try {
            const response = await ApiGetChecklistPdf(data);

            const blob = new Blob([response.data], { type: 'application/pdf' });

            if (blob.size === 0) {
                throw new Error("Empty PDF file.");
            }
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = `${name}_${month?.month()+1}_${month?.year()}.pdf`; // custom file name
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            // setPdfUrl(url); // this will trigger rendering the PDF
        } catch (error: any) {
            console.log(error)
        }
    };
    return (
        <Box>
            <Box className='d-flex align-items-center justify-content-between'>
                <Typography variant='h5' className='fw-bold'>Dashboard</Typography>
                <Box className='d-flex align-items-center gap-3 justify-content-end'>
                    {setCheckListType && (
                        <FormControl size="small" sx={{ minWidth: "160px", bgcolor: "white" }}>
                            <InputLabel id="checklist-type-select-label">Check list view</InputLabel>
                            <Select
                                labelId="checklist-type-select-label"
                                id="checklist-type-select"
                                value={checkListType}
                                label="Check list view"
                                onChange={(e) => {
                                    const val = e.target.value as string;
                                    setCheckListType(val);
                                    storage.setItem('dashboardCheckListType', val);
                                }}
                            >
                                <MenuItem value="BUSINESS">Sites</MenuItem>
                                <MenuItem value="AREA_MANAGER">Areas</MenuItem>
                            </Select>
                        </FormControl>
                    )}
                    {window.location.hostname.includes('aldi') && Regions?.length > 1 && (
                        <FormControl sx={{ width: 'fit-content', minWidth: '100px' }}>
                            <InputLabel id="demo-simple-select-label" shrink={false}>Region: &nbsp;</InputLabel>
                            <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                defaultValue={Regions[0]?.regionId}
                                value={selectedRegion}
                                onChange={(e) => { setselectedRegion(e.target.value) }}
                            >
                                {Regions?.map((item: any, index: number) => (
                                    <MenuItem key={index} value={item.regionId}>
                                        {item.regionName}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    )}
                    {!isAreaManager && venuelist?.length > 1 && (
                        <FormControl sx={{ width: 'fit-content', minWidth: '200px' }}>
                            {/* <InputLabel id="demo-simple-select-label" shrink={true}>Sites:</InputLabel> */}
                            <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={venues}
                                onChange={(e) => { setvenues(e.target.value) }}
                            >
                                {venuelist?.map((item: any, index: number) => (
                                    <MenuItem key={index} value={item.venueId}>
                                        {item.venueName}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    )}
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker value={month}
                            sx={{ maxWidth: "120px" }}
                            views={['month', 'year']}
                            format="MMM-YY"
                            label='Month'
                            onChange={(e: any) => {
                                const isoString = e?.startOf('month').toISOString();
                                dispatch(setSelectedMonth(isoString));
                            }}
                            slots={{
                                openPickerIcon: ArrowDropDownIcon,
                            }}
                        />
                    </LocalizationProvider>
                    {userRole === 'clientadmin' && (
                        <Button className='btn-main' onClick={() => { navigate('/maindashboard/Checklist/checklist-list') }}>Manage Checklist</Button>
                    )}
                </Box>
            </Box>
            <Grid container className='mt-4' alignItems={'stretch !important'} spacing={2}>
                <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }} bgcolor={"var(--primary-light-main-color) !important"} className={`p-3 bg-light-main2  border-10 d-flex align-items-start justify-content-between`}>
                    <Box>
                        <Box className='d-flex align-items-center gap-2 mb-2'>
                            <Box className='p-2 border-10' sx={{ width: 'fit-content' }} bgcolor={'var(--primary-light-main-color)'}>
                                <Security className='text-main' sx={{ fontSize: "26px" }} />
                            </Box>
                            <Typography variant='body1'>Overall Compliance</Typography>
                        </Box>
                        <Box className='d-flex align-items-baseline gap-2'>
                            <Typography variant='h4' className='fw-bold mb-1'>{overview?.totalCompliancePercentage}%</Typography>
                            <Box borderRadius={'5px'} className='px-2 align-items-center d-flex py-0' bgcolor={overview?.complianceChangePercentage > -1 ? 'var(--primary-light-main-color)' : "#FF00001A"} border={overview?.complianceChangePercentage > -1 ? '1px solid var(--primary-color)' : "#FF0000"}>
                                {overview?.complianceChangePercentage > -1 ? (<NorthOutlined className='text-main m-0 p-0' sx={{ fontSize: '12px' }} />) : (<SouthOutlined className='text-danger m-0 p-0' sx={{ fontSize: '12px' }} />)} <Typography variant='caption'>{overview?.complianceChangePercentage}%</Typography>
                            </Box>
                        </Box>
                        <Box className='d-flex align-items-center gap-1'><Typography variant='caption'>vs last 30 days</Typography></Box>
                        {/* <LinearProgress
                            className='mt-2'
                            variant="determinate"
                            value={70}
                            aria-label="Export data"
                            sx={{
                                height: 8,
                                borderRadius: 5,
                                backgroundColor: "var(--primary-light-main-color)",
                                "& .MuiLinearProgress-bar": {
                                    background: "var(--primary-color)",
                                    borderRadius: 5,
                                },
                            }}
                        /> */}
                    </Box>
                    <Box sx={{ position: "relative", display: "inline-flex" }}>
                        {/* Background Track */}
                        <CircularProgress
                            variant="determinate"
                            value={100}
                            size={60}
                            thickness={5}
                            sx={{
                                color: "var(--primary-light-main-color) !important",
                            }}
                        />

                        {/* Filled Progress */}
                        <CircularProgress
                            variant="determinate"
                            value={overview?.totalCompliancePercentage}
                            size={60}
                            thickness={5}
                            sx={{
                                position: "absolute",
                                left: 0,
                                color: "var(--primary-color)",
                                "& .MuiCircularProgress-circle": {
                                    strokeLinecap: "round",
                                },
                            }}
                        />

                    </Box>
                </Grid>
                <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }} bgcolor={"var(--secondary-light-color) !important"} border={'1px solid var(--secondary-color) !important'} className={`p-3 ${isNotMM} border-10 d-flex align-items-start justify-content-between`}>
                    <Box>
                        <Box className='d-flex align-items-center gap-2 mb-2'>
                            <Box className='p-2 border-10' sx={{ width: 'fit-content' }} bgcolor={'var(--secondary-light-color)'}><PendingActions className='text-blue' sx={{ fontSize: "26px" }} /></Box>
                            <Typography variant='body1'>Checklists Due Today</Typography>
                        </Box>
                        <Typography variant='h4' className='fw-bold mb-1'>{overview?.totalDueTillToday}</Typography>
                        <Box className='d-flex align-items-center gap-1'><Typography variant='caption'>{overview?.todayDueCount} <span className='text-secondary'>Pending </span> &nbsp;  {overview?.overdueCount} <span className='text-red'>Overdue</span></Typography></Box>

                    </Box>
                </Grid>
                <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }} bgcolor={"var(--primary-light-main-color) !important"} className={`p-3 bg-light-main2 border-10 d-flex align-items-start justify-content-between`}>
                    <Box>
                        <Box className='d-flex align-items-center gap-2 mb-2'>
                            <Box className='p-2 border-10' sx={{ width: 'fit-content' }} bgcolor={'var(--primary-light-main-color)'}><MilitaryTechOutlined className='text-main' sx={{ fontSize: "26px" }} /></Box>
                            <Typography variant='body1'>Completion Rate (MTD)</Typography>
                        </Box>
                        <Box className='d-flex align-items-baseline gap-1'>
                            <Typography variant='h4' className='fw-bold mb-1'>{overview?.completionRate}%</Typography>
                            <Box borderRadius={'5px'} className='px-2 align-items-center d-flex py-0' bgcolor={overview?.complianceChangePercentage > -1 ? 'var(--primary-light-main-color)' : "#FF00001A"} border={overview?.complianceChangePercentage > -1 ? '1px solid var(--primary-color)' : "#FF0000"}>
                                {overview?.complianceChangePercentage > -1 ? (<NorthOutlined className='text-main m-0 p-0' sx={{ fontSize: '12px' }} />) : (<SouthOutlined className='text-danger m-0 p-0' sx={{ fontSize: '12px' }} />)} <Typography variant='caption'>{overview?.complianceChangePercentage}%</Typography>
                            </Box>
                        </Box>
                        <Box className='d-flex align-items-center gap-1'>
                            <Typography variant='caption'> vs last month</Typography>
                        </Box>

                    </Box>
                    <Box sx={{ position: "relative", display: "inline-flex" }}>
                        {/* Background Track */}
                        <CircularProgress
                            variant="determinate"
                            value={100}
                            size={60}
                            thickness={5}
                            sx={{
                                color: "var(--primary-light-main-color) !important",
                            }}
                        />

                        {/* Filled Progress */}
                        <CircularProgress
                            variant="determinate"
                            value={overview?.completionRate}
                            size={60}
                            thickness={5}
                            sx={{
                                position: "absolute",
                                left: 0,
                                color: "var(--primary-color)",
                                "& .MuiCircularProgress-circle": {
                                    strokeLinecap: "round",
                                },
                            }}
                        />

                    </Box>
                </Grid>
                <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }} bgcolor={"var(--third-light-color) !important"} border={'1px solid var(--third-color) !important'} className={`p-3 ${isNotMM} border-10 d-flex align-items-start justify-content-between`}>
                    <Box>
                        <Box className='d-flex align-items-center gap-2 mb-2'>
                            <Box className='p-2 border-10' sx={{ width: 'fit-content' }} bgcolor={'var(--third-light-color)'}><ReportProblemOutlined className='text-secondary' sx={{ fontSize: "26px" }} /></Box>
                            <Typography variant='body1'>Failures</Typography>
                        </Box>
                        <Box className='d-flex align-items-baseline gap-1'>
                            <Typography variant='h4' className='fw-bold mb-1'>{overview?.failurePercentage}%</Typography>
                            <Box borderRadius={'5px'} className='px-2 align-items-center d-flex py-0' bgcolor={overview?.failureChangePercentage > -1 ? 'var(--primary-light-main-color)' : "#FF00001A"} border={overview?.failureChangePercentage > -1 ? '1px solid var(--primary-color)' : "#FF0000"}>
                                {overview?.failureChangePercentage > -1 ? (<NorthOutlined className='text-main m-0 p-0' sx={{ fontSize: '12px' }} />) : (<SouthOutlined className='text-danger m-0 p-0' sx={{ fontSize: '12px' }} />)} <Typography variant='caption'>{overview?.failureChangePercentage}%</Typography>
                            </Box>
                        </Box>
                        <Box className='d-flex align-items-center gap-1'>
                            <Typography variant='caption'>vs last month</Typography>

                        </Box>

                    </Box>

                    <Box sx={{ position: "relative", display: "inline-flex" }}>
                        {/* Background Track */}
                        <CircularProgress
                            variant="determinate"
                            value={100}
                            size={60}
                            thickness={5}
                            sx={{
                                color: "var(--third-light-color) !important",
                            }}
                        />

                        {/* Filled Progress */}
                        <CircularProgress
                            variant="determinate"
                            value={overview?.failurePercentage}
                            size={60}
                            thickness={5}
                            sx={{
                                position: "absolute",
                                left: 0,
                                color: "var(--third-color)",
                                "& .MuiCircularProgress-circle": {
                                    strokeLinecap: "round",
                                },
                            }}
                        />

                    </Box>

                </Grid>
                {!(userRole === 'clientadmin' && isAreaManager) && (
                    <Grid size={{ xs: 12, md: 6, xl: 4 }} className={`d-flex flex-column ${isNotMM} border-10 overflow-hidden`}>
                        <Box className='d-flex align-items-center mm-card-gradient p-3  justify-content-between'>
                            <Typography className='fw-bold' variant='h6'>Checklists</Typography>
                        </Box>
                        <Box className='p-3 pt-0' flex={1}>
                            {venues && (<VenueChecklistList key={`${month}-${venues}`} venues={venues} month={month} />)}
                        </Box>
                    </Grid>
                )}
                <Grid size={{ xs: 12, md: 6, xl: 4 }}>
                    <Box className={`d-flex flex-column h-100 ${isNotMM} border-10 mb-3 overflow-hidden`}>
                        <Box className='d-flex align-items-center mm-card-gradient p-3 justify-content-between'>
                            <Typography className='fw-bold' variant='h6'>Recent Submissions</Typography>
                        </Box>
                        <Box flex={1} className='p-3'>
                            <Box className='h-100'>
                                {submittedChecklist?.length > 0 ? (
                                    <Box className='d-flex h-100 flex-column'>
                                        <Box flex={1}>
                                            {
                                                submittedChecklist?.map((item: any) => (
                                                    <Box className='mb-2 pb-2 p-2 border' borderRadius={'5px'} borderLeft={`3px solid ${item?.resultStatus === "PASS" ? "var(--primary-color) !important" : "#BF613B !important"}`} >
                                                        <Box className='d-flex align-items-center justify-content-between gap-3'>
                                                            <Box>
                                                                <Typography variant='body2' className='fw-bold m-0 mt-1 p-0' lineHeight={'normal'}>{item?.businessCheckListTitle}</Typography>
                                                                <Typography variant='caption'>{item?.userName} - {dayjs(item?.submittedOn).fromNow()}</Typography>
                                                            </Box>
                                                            <Box className='d-flex align-items-center gap-2'>
                                                                <Typography variant='caption' sx={{ borderRadius: '5px', padding: "0px 8px", border: `1px solid ${item?.resultStatus === "PASS" ? "var(--primary-color)" : "#BF613B"} ` }} bgcolor={item?.resultStatus === "PASS" ? 'var(--primary-light-main-color)' : "#BF613B2A"}>{item?.resultStatus}</Typography>
                                                                <Tooltip title='View Checklist'>
                                                                    <IconButton onClick={() => { navigate(`/maindashboard/checklist/checklist-list/checklist-questions/${item?.businessCheckListSubmissionId}`) }} className='m-0 p-0'>
                                                                        <VisibilityOutlined />
                                                                    </IconButton>
                                                                </Tooltip>
                                                                <Tooltip title='Download pdf'>
                                                                    <IconButton onClick={() => {downloadChecklist(item?.businessCheckListSubmissionId,item?.businessCheckListTitle,item?.areaId)}} className='m-0 p-0'>
                                                                        <Download className='text-main' />
                                                                    </IconButton>
                                                                </Tooltip>
                                                                {/* <Typography variant='caption' className='px-3 py-1 border-10 fw-bold' sx={{ color: item?.resultStatus === "PASS" ? "var(--primary-color)" : "#BF613B" }}>{item?.resultStatus}</Typography> */}
                                                            </Box>
                                                        </Box>

                                                    </Box>
                                                ))
                                            }
                                        </Box>
                                        {totalCount > limit && (
                                            <Box display="flex" justifyContent="center" mt={2}>
                                                <Pagination
                                                    page={page}
                                                    sx={{
                                                        "& .MuiPaginationItem-root.Mui-selected": {
                                                            backgroundColor: 'var(--primary-color)'
                                                        }
                                                    }}
                                                    count={Math.ceil(totalCount / limit)}
                                                    color="primary"
                                                    onChange={(_, value) => setPage(value)}
                                                />
                                            </Box>
                                        )}
                                    </Box>
                                ) : (
                                    <Box className='d-flex h-100  align-items-center justify-content-center'>
                                        <Typography>No Data Found</Typography>
                                    </Box>
                                )}
                            </Box>
                        </Box>
                    </Box>
                </Grid>
                <Grid size={{ xs: 12, md: 6, xl: 4 }}>
                    <Box className={`d-flex flex-column h-100 ${isNotMM} border-10 overflow-hidden`}>
                        <Typography className='fw-bold  mm-card-gradient p-3' variant='h6'>Recent Issues</Typography>
                        <Box className="mt-3 d-flex flex-column p-3 pt-0" flex={1}>
                            <Box flex={1}>
                                {riPaginatedData?.length > 0 ? (<Box>
                                    {
                                        riPaginatedData?.map((item: any) => (
                                            <Box className='p-3 mb-3' sx={{ borderRadius: "5px" }} borderLeft={'3px solid #BF613B'} boxShadow={'0px 0px 5px #ccc'}>
                                                <Box className='d-flex align-items-start justify-content-between'>
                                                    <Box>
                                                        <Typography variant='body1' className='fw-bold'>{item?.questionTitle}</Typography>
                                                        <Typography variant='caption'>{dayjs(item?.lastReportedOn).format("DD MMM YYYY, h:mm A")}</Typography>
                                                    </Box>
                                                    <Typography variant='caption' sx={{ borderRadius: '5px', padding: "0px 8px", border: `1px solid ${item?.status !== "CRITICAL" ? "var(--primary-color)" : "#BF613B"} ` }} bgcolor={item?.status !== "CRITICAL" ? 'var(--primary-light-main-color)' : "#BF613B2A"}>{item?.status}</Typography>
                                                    {/* <Box borderRadius={'10px'} className='px-3 py-1 align-items-center d-flex py-0' bgcolor={item?.status !== "CRITICAL" ? 'var(--primary-light-main-color)' : "#FF00001A"} border={item?.status !== "CRITICAL" ? '1px solid var(--primary-color)' : "#FF0000"}>
                                                        <Typography variant='caption' sx={{ color: item?.status !== "CRITICAL" ? "var(--primary-color)" : "#BF613B" }}>{item?.status}</Typography>
                                                    </Box> */}
                                                </Box>
                                            </Box>
                                        ))
                                    }
                                </Box>
                                ) : (
                                    <Box className='d-flex h-100 w-100 align-items-center justify-content-center'>
                                        <Typography>No Data Found</Typography>
                                    </Box>
                                )}
                            </Box>
                            {riTotalPages > 1 && (
                                <Box display="flex" justifyContent="center" mt={2}>
                                    <Pagination
                                        page={riPage}
                                        sx={{
                                            "& .MuiPaginationItem-root.Mui-selected": {
                                                backgroundColor: 'var(--primary-color)'
                                            }
                                        }}
                                        count={riTotalPages}
                                        color="primary"
                                        onChange={(_, value) => setPage2("ri", value)}
                                    />
                                </Box>
                            )}
                        </Box>
                    </Box>
                </Grid>
                <Grid size={{ xs: 12, md: 6, xl: 3 }} className={`${isNotMM} border-10 overflow-hidden`}>
                    <Box>
                        <Typography variant='h6' className='text-dark p-3 fw-bold mm-card-gradient'>Checklist Performance</Typography>
                        <Box className='p-3'>
                            <Box className='mb-3'>
                                <Box className='d-flex align-items-center justify-content-between'>
                                    <Box>
                                        <Typography variant='body1' className='text-dark fw-bold my-0'>Schedule</Typography>
                                        <Typography variant='caption' className='text-dark my-0'>Total checklists</Typography>
                                    </Box>
                                    <Box className='d-flex align-items-center gap-2'>
                                        <Typography variant='h5' className='fw-bold'>{checklistPerformance?.scheduledCount}</Typography>
                                        <Typography variant='body1'>{checklistPerformance?.scheduledPercentage}%</Typography>
                                    </Box>
                                </Box>
                                <LinearProgress
                                    className='mt-2'
                                    variant="determinate"
                                    value={checklistPerformance?.scheduledPercentage || 0}
                                    aria-label="Export data"
                                    sx={{
                                        height: 30,
                                        borderRadius: 5,
                                        backgroundColor: "#BF613B1A",
                                        "& .MuiLinearProgress-bar": {
                                            // background: "linear-gradient(90deg, #BF613B2A, #BF613B)",
                                            background: "var(--primary-color)",
                                            borderRadius: 5,
                                        },
                                    }}
                                />
                            </Box>
                            <Box className='mb-3'>
                                <Box className='d-flex align-items-center justify-content-between'>
                                    <Box>
                                        <Typography variant='body1' className='text-dark fw-bold my-0'>Submitted</Typography>
                                        <Typography variant='caption' className='text-dark my-0'>Completed by site</Typography>
                                    </Box>
                                    <Box className='d-flex align-items-center gap-2'>
                                        <Typography variant='h5' className='fw-bold'>{checklistPerformance?.submittedCount}</Typography>
                                        <Typography variant='body1'>{checklistPerformance?.submittedPercentage}%</Typography>
                                    </Box>
                                </Box>
                                <LinearProgress
                                    className='mt-2'
                                    variant="determinate"
                                    value={checklistPerformance?.submittedPercentage || 0}
                                    aria-label="Export data"
                                    sx={{
                                        height: 30,
                                        borderRadius: 5,
                                        backgroundColor: "#BF613B1A",
                                        "& .MuiLinearProgress-bar": {
                                            // background: "linear-gradient(90deg, #BF613B2A, #BF613B)",
                                            background: "var(--primary-color)",
                                            borderRadius: 5,
                                        },
                                    }}
                                />
                            </Box>
                            <Box className='mb-3'>
                                <Box className='d-flex align-items-center justify-content-between'>
                                    <Box>
                                        <Typography variant='body1' className='text-dark fw-bold my-0'>Passed</Typography>
                                        <Typography variant='caption' className='text-dark my-0'>Compliant checklist</Typography>
                                    </Box>
                                    <Box className='d-flex align-items-center gap-2'>
                                        <Typography variant='h5' className='fw-bold'>{checklistPerformance?.passedCount}</Typography>
                                        <Typography variant='body1'>{checklistPerformance?.passedPercentage}%</Typography>
                                    </Box>
                                </Box>
                                <LinearProgress
                                    className='mt-2'
                                    variant="determinate"
                                    value={checklistPerformance?.passedPercentage || 0}
                                    aria-label="Export data"
                                    sx={{
                                        height: 30,
                                        borderRadius: 5,
                                        backgroundColor: "#BF613B1A",
                                        "& .MuiLinearProgress-bar": {
                                            // background: "linear-gradient(90deg, #BF613B2A, #BF613B)",
                                            background: "var(--primary-color)",
                                            borderRadius: 5,
                                        },
                                    }}
                                />
                            </Box>
                            <Box className='mb-3'>
                                <Box className='d-flex align-items-center justify-content-between'>
                                    <Box>
                                        <Typography variant='body1' className='text-dark fw-bold my-0'>Failed</Typography>
                                        <Typography variant='caption' className='text-dark my-0'>Non-compliant</Typography>
                                    </Box>
                                    <Box className='d-flex align-items-center gap-2'>
                                        <Typography variant='h5' className='fw-bold'>{checklistPerformance?.failedCount}</Typography>
                                        <Typography variant='body1'>{checklistPerformance?.failedPercentage}%</Typography>
                                    </Box>
                                </Box>
                                <LinearProgress
                                    className='mt-2'
                                    variant="determinate"
                                    value={checklistPerformance?.failedPercentage || 0}
                                    aria-label="Export data"
                                    sx={{
                                        height: 30,
                                        borderRadius: 5,
                                        backgroundColor: "#BF613B1A",
                                        "& .MuiLinearProgress-bar": {
                                            // background: "linear-gradient(90deg, #BF613B2A, #BF613B)",
                                            background: "var(--primary-color)",
                                            borderRadius: 5,
                                        },
                                    }}
                                />
                            </Box>
                            <Box className='mb-3'>
                                <Box className='d-flex align-items-center justify-content-between'>
                                    <Box>
                                        <Typography variant='body1' className='text-dark fw-bold my-0'>Non Submitted</Typography>
                                        <Typography variant='caption' className='text-dark my-0'>Missed / Overdue</Typography>
                                    </Box>
                                    <Box className='d-flex align-items-center gap-2'>
                                        <Typography variant='h5' className='fw-bold'>{checklistPerformance?.notSubmittedCount}</Typography>
                                        <Typography variant='body1'>{checklistPerformance?.notSubmittedPercentage}%</Typography>
                                    </Box>
                                </Box>
                                <LinearProgress
                                    className='mt-2'
                                    variant="determinate"
                                    value={checklistPerformance?.notSubmittedPercentage || 0}
                                    aria-label="Export data"
                                    sx={{
                                        height: 30,
                                        borderRadius: 5,
                                        backgroundColor: "#BF613B1A",
                                        "& .MuiLinearProgress-bar": {
                                            // background: "linear-gradient(90deg, #BF613B2A, #BF613B)",
                                            background: "var(--primary-color)",
                                            borderRadius: 5,
                                        },
                                    }}
                                />
                            </Box>
                        </Box>
                    </Box>
                </Grid>
                <Grid size={{ xs: 12, md: 8, xl: 6 }} className={`${isNotMM} border-10 overflow-hidden`}>
                    <Box className='d-flex align-items-start w-100 mm-card-gradient p-3  justify-content-between'>
                        <Box>
                            <Typography className='fw-bold' variant='h6'>Checklist Compliance</Typography>
                            <Typography variant='body2'>Compliant vs failed checklists from total submitted each month</Typography>
                        </Box>
                        {/* <Box className='d-flex align-items-center gap-3 p-3'>
                            <Box className='d-flex align-items-center gap-1'>
                                <Box height={'10px'} width={'10px'} borderRadius={'50px'} bgcolor={"var(--primary-color)"}></Box>
                                <Typography variant='caption'>Compliant</Typography>
                            </Box>
                            <Box className='d-flex align-items-center gap-1'>
                                <Box height={'10px'} width={'10px'} borderRadius={'50px'} bgcolor={"#BF613B"}></Box>
                                <Typography variant='caption'>Failed</Typography>
                            </Box>
                        </Box> */}
                    </Box>
                    <Grid container spacing={1} className='my-3'>
                        <Grid size={{ xs: 12, md: 6, lg: 4 }} className='p-2 px-3 border-10' bgcolor={'#FFFFFF9A'}>
                            <Typography variant='body2' gutterBottom>TOTAL SUBMITEED</Typography>
                            <Box className='d-flex align-items-baseline gap-2'>
                                <Typography variant='h5' className='fw-bold'>{analytics?.totalSubmittedCount?.currentMonth}</Typography>
                                <Typography variant='caption' className='fw-bold' sx={{ color: analytics?.totalSubmittedCount?.trend == "UP" ? "var(--primary-color)" : "#BF613B" }}>{analytics?.totalSubmittedCount?.trend == "UP" ? "+" : "-"} {analytics?.totalSubmittedCount?.percentage}%</Typography>
                            </Box>
                        </Grid>
                        <Grid size={{ xs: 12, md: 6, lg: 4 }} className='p-2 px-3 border-10' bgcolor={'#FFFFFF9A'}>
                            <Typography variant='body2' gutterBottom>COMPLIANCE RATE</Typography>
                            <Box className='d-flex align-items-baseline gap-2'>
                                <Typography variant='h5' className='fw-bold'>{analytics?.complianceRate?.currentMonth}%</Typography>
                                <Typography variant='caption' className='fw-bold' sx={{ color: analytics?.complianceRate?.trend == "UP" ? "var(--primary-color)" : "#BF613B" }}>{analytics?.complianceRate?.trend == "UP" ? "+" : "-"} {analytics?.complianceRate?.percentage}%</Typography>
                            </Box>
                        </Grid>
                        <Grid size={{ xs: 12, md: 6, lg: 4 }} className='p-2 px-3 border-10' bgcolor={'#FFFFFF9A'}>
                            <Typography variant='body2' gutterBottom>FAILED SUBMISSION</Typography>
                            <Box className='d-flex align-items-baseline gap-2'>
                                <Typography variant='h5' className='fw-bold'>{analytics?.totalFailedCount?.currentMonth}</Typography>
                                <Typography variant='caption' className='fw-bold' sx={{ color: analytics?.totalFailedCount?.trend == "UP" ? "var(--primary-color)" : "#BF613B" }}>{analytics?.totalFailedCount?.trend == "UP" ? "+" : "-"} {analytics?.totalFailedCount?.percentage}%</Typography>
                            </Box>
                        </Grid>
                    </Grid>
                    <Box maxHeight={'380px'}>
                        <ChecklistChart data={analytics?.lastSixMonths || []} />
                    </Box>
                </Grid>
                <Grid size={{ xs: 12, md: 4, xl: 3 }} className={`d-flex flex-column ${isNotMM} border-10 overflow-hidden`}>
                    <Typography variant='h6' className='fw-bold p-3 mm-card-gradient'>Failure by Checklist</Typography>
                    <Box flex={1} className='p-3 pt-0'>
                        {failureByChecklist?.list?.length > 0 ? (
                            <Box>
                                <RoundChart data={failureByChecklist?.list} />
                            </Box>
                        ) : (
                            <Box className='d-flex h-100 w-100 align-items-center justify-content-center'>
                                <Typography>No Data Found</Typography>
                            </Box>
                        )}
                    </Box>
                </Grid>
                <Grid size={{ xs: 12 }} className={`${isNotMM} border-10 overflow-hidden`}>
                    <Box className='d-flex align-items-baseline gap-1 p-3 mm-card-gradient'>
                        <Typography className='fw-bold' variant='h6'>Compliance by Category</Typography>
                        <Typography variant='caption'>(Last 7 Days)</Typography>
                    </Box>
                    <Grid container spacing={2} className='p-3'>
                        {cbcPaginatedData?.length > 0 ?
                            cbcPaginatedData?.map((item: any) => (
                                <Grid size={'grow'} className={`p-3 d-flex flex-column justify-content-between border-10 ${isNotMM}`} bgcolor={'#FFFFFF7A'}>
                                    <Typography variant='body2' gutterBottom>{item?.categoryName}</Typography>
                                    <Box>
                                        <Typography variant='h5'>{item?.compliancePercentage}%</Typography>
                                        <LinearProgress
                                            className='mt-2'
                                            variant="determinate"
                                            value={item?.compliancePercentage}
                                            aria-label="Export data"
                                            sx={{
                                                height: 8,
                                                borderRadius: 5,
                                                backgroundColor: "var(--primary-light-main-color)",
                                                "& .MuiLinearProgress-bar": {
                                                    background: "var(--primary-color)",
                                                    borderRadius: 5,
                                                },
                                            }}
                                        />
                                    </Box>
                                </Grid>
                            ))

                            : (
                                <Grid size='grow'><Typography className='text-center'>No Data Found</Typography></Grid>
                            )}

                    </Grid>
                    {cbcTotalPages > 1 && (
                        <Box display="flex" justifyContent="center" my={2}>
                            <Pagination
                                page={cbcPage}
                                sx={{
                                    "& .MuiPaginationItem-root.Mui-selected": {
                                        backgroundColor: 'var(--primary-color)'
                                    }
                                }}
                                count={cbcTotalPages}
                                color="primary"
                                onChange={(_, value) => setPage2("cbc", value)}
                            />
                        </Box>
                    )}
                </Grid>
            </Grid>
        </Box>
    )
}

export default VenueChecklistDashboard
